import {
    type CreateAnnouncementResponseType,
    type CreateAnnouncementRequestType
} from "./type";
import {
    request
} from "../request";

const CreateAnnouncement = async (params: CreateAnnouncementRequestType): Promise<CreateAnnouncementResponseType> => {
    return await request<CreateAnnouncementResponseType>("/announcement/createAnnouncement", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default CreateAnnouncement;
